export default "__VITE_ASSET___Y7J9AUs__"